import { Button } from "@/components/ui/button";
import { useLeadForm } from "@/features/leads/contexts/FormLeadContext";
import { onInvalid } from "@/features/leads/contexts/FormLeadContext";
import { useChildForm } from "@/features/leads/contexts/ChildProvider";
import { setIsEditMode } from "@/features/leads/stores/leadFunctionalSlice";
import { useAppDispatch } from "@/stores/hook";
import { useEditLeadPhoneCheck } from "@/features/leads/hooks/useEditLeadPhoneCheck";
import { dealStageIdOf, useCanEditDeal } from "@/rbac/useCanEditDeal";

export default function ActionsForEditMode() {
  const { onSubmit, handleSubmit } = useLeadForm();
  const {
    currentChildId,
    child,
    getValues: getChildValues,
    onSubmit: childOnSubmit,
  } = useChildForm();
  const canEditDeal = useCanEditDeal();
  const dispatch = useAppDispatch();

  // Shares the query key with the Mobile field's inline warning, so this
  // button and that message can never disagree. Server-side uniqueness is
  // still the enforcement.
  //
  // `blocksSave` — NOT `isDuplicate` — because the server only rejects a
  // duplicate when the number actually CHANGES. Blocking on `isDuplicate`
  // disabled Save on every lead that merely shares a number with another
  // row (and this tenant has hundreds), making those leads uneditable.
  const phoneCheck = useEditLeadPhoneCheck();

  const handleCancel = () => {
    dispatch(setIsEditMode(false));
  };

  const handleSave = () => {
    // Pass onInvalid so zod validation failures surface a toast instead of
    // silently blocking the save (used to mask "country code didn't save"
    // when an unrelated required field like followUpDate was empty).
    handleSubmit(onSubmit, onInvalid)();
    // The deal half is a deal data edit — skipped (the lead half still
    // saves) when the role can't "Edit choices" on the deal's own stage.
    if (currentChildId && canEditDeal(dealStageIdOf(child))) {
      childOnSubmit(getChildValues());
    }
  };

  return (
    <div className=" flex items-center justify-end ">
      <div className="flex gap-[16px] items-center justify-end">
        <Button variant="cancel" onClick={handleCancel}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleSave}
          disabled={phoneCheck.blocksSave}
          title={
            phoneCheck.blocksSave
              ? phoneCheck.message ?? "This number already exists"
              : undefined
          }
          className={
            phoneCheck.blocksSave ? "opacity-70 cursor-not-allowed" : ""
          }
        >
          Save lead
        </Button>
      </div>
    </div>
  );
}
